import { AfterViewInit, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AnimationService } from '../../../services/animation.service';

interface FaqItem {
  question: string;
  answer: string;
  isOpen: boolean;
}

interface ExtraQuestions {
  email: string;
  firstName: string;
  lastName: string;
  message: string;
}

import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';

@Component({
  selector: 'app-faqs-component',
  imports: [FormsModule, CommonModule, ...TRANSLATIONS_IMPORTS, ...MATERIAL_IMPORTS],
  templateUrl: './faqs-component.html',
  styleUrl: './faqs-component.scss',
})
export class FaqsComponent implements AfterViewInit {
  private readonly notification = inject(NotificationService);
  private readonly animation = inject(AnimationService);

  ngAfterViewInit() {
    this.animation.scrollAnimate('.faqs-section');
  }

  faqs: FaqItem[] = [
    {
      question: 'What is the Government MEL System and who is it for?',
      answer: `The Government Monitoring, Evaluation and Learning (MEL) System is a national digital platform designed to support ministries, departments, and agencies in tracking development projects, measuring outcomes against set indicators, and capturing lessons for adaptive planning. It is primarily for government institutions operating under Vision 2050 and the National Development Plan.`,
      isOpen: true,
    },
    {
      question: 'How do I register my institution on the MEL system?',
      answer: `Institutional registration is handled by the eGovernment Authority. An authorised focal person requests access, after which the institution is provisioned with an admin account. The admin can then create departmental users and assign roles within the system.`,
      isOpen: false,
    },
    {
      question: 'What types of data can be submitted and tracked in the system?',
      answer: `The system tracks strategic plans, annual workplans, project phases, components and milestones, indicators and targets, beneficiary data, budgets and expenditure, risks and issues, progress reports, and impact assessments — both quantitative and qualitative.`,
      isOpen: false,
    },
    {
      question: 'Is data on the MEL system secure and who has access?',
      answer: `Yes. Access is role-based and scoped to each institution — users only see and manage data for the institution they belong to. Data is transmitted securely and stored under government data-governance standards, with audit trails on key actions.`,
      isOpen: false,
    },
    {
      question: 'How often should institutions submit data and reports?',
      answer: `Reporting follows the national reporting calendar — typically quarterly for progress reports and annually for plans and evaluations — though indicator data can be submitted continuously as activities are implemented.`,
      isOpen: false,
    },
    {
      question: 'Can I access and download reports and analytics from the system?',
      answer: `Authorised users can view live dashboards and export reports and analytics (Excel/PDF) for their institution, including progress summaries, budget utilisation, and results against indicators.`,
      isOpen: false,
    },
    {
      question: 'What support and training is available for new users?',
      answer: `The MEL support team provides onboarding, user guides, and training sessions for institutional administrators and reporting officers, plus ongoing helpdesk assistance for technical and reporting questions.`,
      isOpen: false,
    },
  ];

  toggleFaq(index: number) {
    this.faqs = this.faqs.map((faq, i) => ({
      ...faq,
      isOpen: i === index ? !faq.isOpen : false,
    }));
  }

  extraQuestion: ExtraQuestions = {
    email: '',
    firstName: '',
    lastName: '',
    message: '',
  };

  submitExtraQuestion() {
    console.log(this.extraQuestion);

    // Implementation for submission
    this.notification.success('Your question has been submitted successfully!');

    // Reset values
    this.extraQuestion = {
      email: '',
      firstName: '',
      lastName: '',
      message: '',
    };
  }
}
